var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinked(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 24,
    viewBox: "0 0 44 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 24C18.1046 24 19 23.1046 19 22C19 20.8954 18.1046 20 17 20H12C7.5817 20 4 16.4183 4 12C4 7.5817 7.5817 4 12 4H17C18.1046 4 19 3.1046 19 2C19 0.8954 18.1046 0 17 0H12C5.3726 0 0 5.3726 0 12C0 18.6274 5.3726 24 12 24H17Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27 24C25.8954 24 25 23.1046 25 22C25 20.8954 25.8954 20 27 20H32C36.4183 20 40 16.4183 40 12C40 7.5817 36.4183 4 32 4H27C25.8954 4 25 3.1046 25 2C25 0.8954 25.8954 0 27 0H32C38.6274 0 44 5.3726 44 12C44 18.6274 38.6274 24 32 24H27Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33 12C33 13.1046 32.1046 14 31 14H13C11.8954 14 11 13.1046 11 12C11 10.8954 11.8954 10 13 10H31C32.1046 10 33 10.8954 33 12Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinked);
export default __webpack_public_path__ + "static/media/linked.a186981994c1a743f3eb0b3047272a55.svg";
export { ForwardRef as ReactComponent };